// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"4eaaff64","726":"6fafae6d","977":"6f25db11"}[chunkId] + ".chunk.js";
};